namespace TotalContest {
    import Component = TotalCore.Common.Component;

    @Component('components.totalcontest', {
        templateUrl: 'finish-component-template',
        bindings: {}
    })
    class FinishComponent {

        public constructor(private $scope, public OnBoarding) {

        }
    }
}
